<template>
  <b-card>
    <div slot="header">
      <span v-html="caption"></span>
      <span class="float-right" v-if="tableType === 'dashboard'">
        <b-form-checkbox
          ref="enabled-checkbox-dashboard"
          id="enabled-checkbox-dashboard"
          v-model="enabledState"
          :value="true"
          :unchecked-value="false"
          :indeterminate.sync="enabledIndeterminate"
          @click.native.stop.prevent="enabledClick"
        >Enabled</b-form-checkbox></span>
    </div>
    <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="reserves" :fields="reserveFields" :current-page="currentPage" :per-page="perPage" :show-empty="true" empty-text="No reserves on this date." @row-clicked="onRowClick">
      <template slot="status" slot-scope="data">
        <b-badge :variant="getBadge(data.item.status)">{{data.item.status}}</b-badge>
      </template>
      <template slot="startDate" slot-scope="data">
        {{data.item.startDate}}<span v-show="data.item.checkin"> - <i class="fa fa-check" /></span>
      </template>
      <template slot="stopDate" slot-scope="data">
        {{data.item.stopDate}}<span v-show="data.item.checkout"> - <i class="fa fa-check" /></span>
      </template>
    </b-table>
    <nav>
      <b-pagination :total-rows="getRowCount(reserves)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
    </nav>
  </b-card>
</template>

<script>
/**
   * Randomize array element order in-place.
   * Using Durstenfeld shuffle algorithm.
   */
const shuffleArray = (array) => {
  for (let i = array.length - 1; i > 0; i--) {
    let j = Math.floor(Math.random() * (i + 1))
    let temp = array[i]
    array[i] = array[j]
    array[j] = temp
  }
  return array
}

export default {
  name: 'c-table',
  props: {
    caption: {
      type: String,
      default: 'Table'
    },
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    },
    tableType: {
      type: String,
      default: null
    },
    reserves: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data: () => {
    return {
      reserveFields: [
        {
          key: 'status'
        },
        {
          key: 'id'
        },
        {
          key: 'clientName',
          label: 'Client'
        },
        {
          key: 'apartmentName',
          label: 'Apartment'
        },
        {
          key: 'roomNumber',
          label: 'Room'
        },
        {
          key: 'startDate'
        },
        {
          key: 'stopDate'
        }
      ],
      currentPage: 1,
      perPage: 5,
      totalRows: 0,
      enabledState: true,
      enabledIndeterminate: false,
      enabledStep: 1
    }
  },
  methods: {
    getBadge (status) {
      return status === 'Check-in' ? 'success'
        : status === 'Ongoing' ? 'warning'
          : status === 'Check-out' ? 'danger' : 'secondary'
    },
    getRowCount (items) {
      return items.length
    },
    onRowClick (event) {
      this.$emit('row-clicked', event)
    },
    enabledClick: function(event) {
      this.$nextTick(() => {
        switch (this.enabledStep) {
          case 1:
            this.enabledState = false
            this.enabledIndeterminate = false
            this.enabledStep = 2
            localStorage.dashboardEnabled = false
            this.$emit('dashboard-enabled-toggled')
            break;
          case 2:
            this.enabledState = false
            this.enabledIndeterminate = true
            this.enabledStep = 3
            localStorage.dashboardEnabled = null
            this.$emit('dashboard-enabled-toggled')
            break;
          case 3:
            this.enabledState = true
            this.enabledIndeterminate = false
            this.$refs["enabled-checkbox-dashboard"].setIndeterminate(false); // special function call to reset indeterminate
            this.enabledStep = 1
            localStorage.dashboardEnabled = true
            this.$emit('dashboard-enabled-toggled')
            break;
          default:
            break;
        }
      })
    }
  },
  created: function() {
    if (this.tableType === 'dashboard') {
      switch (localStorage.dashboardEnabled) {
        case 'true':
          this.enabledState = true,
          this.enabledIndeterminate = false,
          this.enabledStep = 1
          break
        case 'false':
          this.enabledState = false,
          this.enabledIndeterminate = false,
          this.enabledStep = 2
          break
        case 'null':
          this.enabledState = false,
          this.enabledIndeterminate = true,
          this.enabledStep = 3
          break
        default:
          break
      }
    }
  }
}
</script>
